export const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu
